import Vue from 'vue';
import Vuex from 'vuex';

import cart from './modules/cart';
import feedback from './modules/feedback';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isBackMove: false,
    isAdmin: false,
    photo: null,
  },
  getters: {},
  mutations: {
    setMoveFlag(state, flag) {
      state.isBackMove = Boolean(flag);
    },
    setPhoto(state, photo) {
      state.photo = photo;
    },
    clearPhoto(state) {
      state.photo = null;
    },
    addAdminPermissions(state) {
      state.isAdmin = true;
    },
    removeAdminPermissions(state) {
      state.isAdmin = false;
    },
  },
  actions: {
    clearSession({ dispatch, commit }) {
      commit('removeAdminPermissions');
      dispatch('cart/tryToCancelOrder');
      dispatch('cart/clearAll');
    },
    parseSearchRequest(ctx, request) {
      return this.$axios.post('/hors/process', request)
        .then(({ data }) => data);
    },
  },
  modules: {
    cart,
    feedback,
  },
  plugins: [],
});
